/* eslint-disable import/order */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// BootstrapVue
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Element UI (English)
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import en from 'element-ui/lib/locale/lang/en'

// Axios
import axios from './api/axios.js'
import VueAxios from 'vue-axios'

// Global styles
import './assets/scss/index.scss'

// Vue config
Vue.config.productionTip = false

// Plugins
Vue.use(VueAxios, axios)
Vue.use(ElementUI, { locale: en })
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

// Vue instance
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
